import { Providers } from '../providers';

interface DappProps {
  enableAbly?: boolean;
  enableDecent?: boolean;
  enableMarketplace?: boolean;
  enableSequence?: boolean;
  children: React.ReactNode;
  chains?: ('evm' | 'sol')[];
  dynamicEnvironmentId?: string;
}

/**
 * Dapp component that provides various providers to its children.
 * @component
 * @param {DappProps} props - The properties for the component.
 * @param {boolean} [props.enableAbly=false] - Whether to enable Ably.
 * @param {boolean} [props.enableDecent=false] - Whether to enable Decent.
 * @param {boolean} [props.enableMarketplace=false] - Whether to enable Marketplace.
 * @param {boolean} [props.enableSequence=false] - Whether to enable Sequence.
 * @param {React.ReactNode} props.children - The child components to be wrapped by the providers.
 * @param {('evm' | 'sol')[]} [props.chains] - The chains to be used.
 * @returns {JSX.Element} The Dapp component.
 */
export const Dapp: React.FC<DappProps> = ({
  enableAbly = false,
  enableDecent = false,
  enableMarketplace = false,
  enableSequence = false,
  children,
  chains,
  dynamicEnvironmentId,
}: DappProps) => {
  return (
    <Providers
      chains={chains}
      enableAbly={enableAbly}
      enableDecent={enableDecent}
      enableMarketplace={enableMarketplace}
      enableSequence={enableSequence}
      dynamicEnvironmentId={dynamicEnvironmentId}
    >
      {children}
    </Providers>
  );
};

export default Dapp;
